import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import * as API from '../../utils/api.service';

export const getCountryListApiCall = createAsyncThunk("countryList", async (submitData, { dispatch }) => {
    try {
        dispatch(setLoader(true))
        const { data: countryList } = await API.getCountryListApi(submitData);
        await Promise.all(countryList?.map(country => {
            country.label = country?.country_code;
            country.value = country?.country_code;
        }))
        dispatch(setLoader(false))
        return countryList;
    } catch (error) {
        throw error;
    }
});

const initialState = {
    isLoading: false,
    countryList: {
        data: [],
        error: null,
    },
}

const masterSlice = createSlice({
    name: 'masterslice',
    initialState,
    reducers: {
        setLoader: (state, action) => {
            state.isLoading = action.payload;
        },
    },
    extraReducers: (builder) => {
        builder
            .addCase(getCountryListApiCall.fulfilled, (state, action) => {
                state.countryList.data = action.payload;
            })
            .addCase(getCountryListApiCall.rejected, (state, action) => {
                state.countryList.error = action.error.message;
            });
    },
});

export const { setLoader } = masterSlice.actions;
export default masterSlice.reducer;